/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateMerchantRequest } from '../models';
// @ts-ignore
import type { CreateProcessorConfigRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { MerchantResponse } from '../models';
// @ts-ignore
import type { MerchantStatus } from '../models';
// @ts-ignore
import type { PagedMerchantResponse } from '../models';
// @ts-ignore
import type { PaymentConfigurationResponse } from '../models';
// @ts-ignore
import type { ProcessorConfiguration } from '../models';
// @ts-ignore
import type { SuspendMerchantRequest } from '../models';
// @ts-ignore
import type { SuspendMerchantResponse } from '../models';
// @ts-ignore
import type { UpdateMerchantRequest } from '../models';
// @ts-ignore
import type { UpdateMerchantStatus } from '../models';
// @ts-ignore
import type { UpdatePaymentConfigurationRequest } from '../models';
/**
 * MerchantsApi - axios parameter creator
 * @export
 */
export const MerchantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new processor configuration to a merchant
         * @summary Create processor configuration
         * @param {string} merchantId Merchant ID
         * @param {CreateProcessorConfigRequest} createProcessorConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchantProcessorV1: async (merchantId: string, createProcessorConfigRequest: CreateProcessorConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createMerchantProcessorV1', 'merchantId', merchantId)
            // verify required parameter 'createProcessorConfigRequest' is not null or undefined
            assertParamExists('createMerchantProcessorV1', 'createProcessorConfigRequest', createProcessorConfigRequest)
            const localVarPath = `/api/v1/merchants/{merchantId}/processors`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProcessorConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Merchant with at least one payment processor
         * @summary Create a new merchant
         * @param {CreateMerchantRequest} createMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchantV1: async (createMerchantRequest: CreateMerchantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMerchantRequest' is not null or undefined
            assertParamExists('createMerchantV1', 'createMerchantRequest', createMerchantRequest)
            const localVarPath = `/api/v1/merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMerchantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update the payment configuration for a merchant (idempotent operation, restricted to partner owning the merchant)
         * @summary Create or update merchant payment configuration
         * @param {string} merchantId Merchant ID
         * @param {UpdatePaymentConfigurationRequest} updatePaymentConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateMerchantPaymentConfigurationV1: async (merchantId: string, updatePaymentConfigurationRequest: UpdatePaymentConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createOrUpdateMerchantPaymentConfigurationV1', 'merchantId', merchantId)
            // verify required parameter 'updatePaymentConfigurationRequest' is not null or undefined
            assertParamExists('createOrUpdateMerchantPaymentConfigurationV1', 'updatePaymentConfigurationRequest', updatePaymentConfigurationRequest)
            const localVarPath = `/api/v1/merchants/{merchantId}/payment-configuration`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a merchant. Can only delete merchants with no payment sessions.
         * @summary Delete merchant
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantV1: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMerchantV1', 'id', id)
            const localVarPath = `/api/v1/merchants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disconnect a processor from a merchant. This operation allows processor deletion regardless of profileId or merchant status.  **Automatic Merchant Status Update:** - If the processor being deleted has status ACTIVE - AND the merchant status is ACTIVE - THEN the merchant status will be automatically changed to INACTIVE - AND a merchant.status.changed event will be emitted  **Validation:** - Processor cannot be deleted if it has active transactions in progress  **Event Emission:** When an ACTIVE processor is deleted from an ACTIVE merchant, a merchant.status.changed event is emitted with: - merchantId: The merchant identifier - previousStatus: \"ACTIVE\" - newStatus: \"INACTIVE\" - reason: \"MANUAL_UPDATE\" - description: Details about the processor deletion 
         * @summary Disconnect processor
         * @param {string} merchantId Merchant ID
         * @param {string} processorId Processor ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectMerchantProcessorV1: async (merchantId: string, processorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('disconnectMerchantProcessorV1', 'merchantId', merchantId)
            // verify required parameter 'processorId' is not null or undefined
            assertParamExists('disconnectMerchantProcessorV1', 'processorId', processorId)
            const localVarPath = `/api/v1/merchants/{merchantId}/processors/{processorId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"processorId"}}`, encodeURIComponent(String(processorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the payment configuration for a merchant (public endpoint)
         * @summary Get merchant payment configuration
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantPaymentConfigurationV1: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantPaymentConfigurationV1', 'merchantId', merchantId)
            const localVarPath = `/api/v1/public/merchants/{merchantId}/payment-configuration`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all processor configurations for a merchant
         * @summary Get merchant processor configurations
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantProcessorsV1: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantProcessorsV1', 'merchantId', merchantId)
            const localVarPath = `/api/v1/merchants/{merchantId}/processors`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Merchant
         * @summary Get merchant by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantV1: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMerchantV1', 'id', id)
            const localVarPath = `/api/v1/merchants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Merchants
         * @summary List merchants
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {MerchantStatus} [status] 
         * @param {string} [taxId] 
         * @param {string} [sort] 
         * @param {ListMerchantsV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantsV1: async (page?: number, size?: number, status?: MerchantStatus, taxId?: string, sort?: string, direction?: ListMerchantsV1DirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (taxId !== undefined) {
                localVarQueryParameter['taxId'] = taxId;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suspend a Merchant (.NET platform only)
         * @summary Suspend merchant
         * @param {string} id 
         * @param {SuspendMerchantRequest} suspendMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendMerchantStatusV1: async (id: string, suspendMerchantRequest: SuspendMerchantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('suspendMerchantStatusV1', 'id', id)
            // verify required parameter 'suspendMerchantRequest' is not null or undefined
            assertParamExists('suspendMerchantStatusV1', 'suspendMerchantRequest', suspendMerchantRequest)
            const localVarPath = `/api/v1/merchants/{id}/suspend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(suspendMerchantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Merchant\'s status (Platform Admin only)
         * @summary Update merchant status
         * @param {string} id 
         * @param {UpdateMerchantStatus} updateMerchantStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantStatusV1: async (id: string, updateMerchantStatus: UpdateMerchantStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMerchantStatusV1', 'id', id)
            // verify required parameter 'updateMerchantStatus' is not null or undefined
            assertParamExists('updateMerchantStatusV1', 'updateMerchantStatus', updateMerchantStatus)
            const localVarPath = `/api/v1/merchants/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Merchant details
         * @summary Update merchant
         * @param {string} id 
         * @param {UpdateMerchantRequest} updateMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantV1: async (id: string, updateMerchantRequest: UpdateMerchantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMerchantV1', 'id', id)
            // verify required parameter 'updateMerchantRequest' is not null or undefined
            assertParamExists('updateMerchantV1', 'updateMerchantRequest', updateMerchantRequest)
            const localVarPath = `/api/v1/merchants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantsApi - functional programming interface
 * @export
 */
export const MerchantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new processor configuration to a merchant
         * @summary Create processor configuration
         * @param {string} merchantId Merchant ID
         * @param {CreateProcessorConfigRequest} createProcessorConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMerchantProcessorV1(merchantId: string, createProcessorConfigRequest: CreateProcessorConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessorConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMerchantProcessorV1(merchantId, createProcessorConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.createMerchantProcessorV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Merchant with at least one payment processor
         * @summary Create a new merchant
         * @param {CreateMerchantRequest} createMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMerchantV1(createMerchantRequest: CreateMerchantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMerchantV1(createMerchantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.createMerchantV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or update the payment configuration for a merchant (idempotent operation, restricted to partner owning the merchant)
         * @summary Create or update merchant payment configuration
         * @param {string} merchantId Merchant ID
         * @param {UpdatePaymentConfigurationRequest} updatePaymentConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateMerchantPaymentConfigurationV1(merchantId: string, updatePaymentConfigurationRequest: UpdatePaymentConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateMerchantPaymentConfigurationV1(merchantId, updatePaymentConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.createOrUpdateMerchantPaymentConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a merchant. Can only delete merchants with no payment sessions.
         * @summary Delete merchant
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMerchantV1(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMerchantV1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.deleteMerchantV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disconnect a processor from a merchant. This operation allows processor deletion regardless of profileId or merchant status.  **Automatic Merchant Status Update:** - If the processor being deleted has status ACTIVE - AND the merchant status is ACTIVE - THEN the merchant status will be automatically changed to INACTIVE - AND a merchant.status.changed event will be emitted  **Validation:** - Processor cannot be deleted if it has active transactions in progress  **Event Emission:** When an ACTIVE processor is deleted from an ACTIVE merchant, a merchant.status.changed event is emitted with: - merchantId: The merchant identifier - previousStatus: \"ACTIVE\" - newStatus: \"INACTIVE\" - reason: \"MANUAL_UPDATE\" - description: Details about the processor deletion 
         * @summary Disconnect processor
         * @param {string} merchantId Merchant ID
         * @param {string} processorId Processor ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectMerchantProcessorV1(merchantId: string, processorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectMerchantProcessorV1(merchantId, processorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.disconnectMerchantProcessorV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the payment configuration for a merchant (public endpoint)
         * @summary Get merchant payment configuration
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantPaymentConfigurationV1(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantPaymentConfigurationV1(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.getMerchantPaymentConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all processor configurations for a merchant
         * @summary Get merchant processor configurations
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantProcessorsV1(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessorConfiguration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantProcessorsV1(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.getMerchantProcessorsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Merchant
         * @summary Get merchant by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantV1(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantV1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.getMerchantV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Merchants
         * @summary List merchants
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {MerchantStatus} [status] 
         * @param {string} [taxId] 
         * @param {string} [sort] 
         * @param {ListMerchantsV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMerchantsV1(page?: number, size?: number, status?: MerchantStatus, taxId?: string, sort?: string, direction?: ListMerchantsV1DirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedMerchantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMerchantsV1(page, size, status, taxId, sort, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.listMerchantsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Suspend a Merchant (.NET platform only)
         * @summary Suspend merchant
         * @param {string} id 
         * @param {SuspendMerchantRequest} suspendMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendMerchantStatusV1(id: string, suspendMerchantRequest: SuspendMerchantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuspendMerchantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendMerchantStatusV1(id, suspendMerchantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.suspendMerchantStatusV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a Merchant\'s status (Platform Admin only)
         * @summary Update merchant status
         * @param {string} id 
         * @param {UpdateMerchantStatus} updateMerchantStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantStatusV1(id: string, updateMerchantStatus: UpdateMerchantStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantStatusV1(id, updateMerchantStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.updateMerchantStatusV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a Merchant details
         * @summary Update merchant
         * @param {string} id 
         * @param {UpdateMerchantRequest} updateMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantV1(id: string, updateMerchantRequest: UpdateMerchantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantV1(id, updateMerchantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantsApi.updateMerchantV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantsApi - factory interface
 * @export
 */
export const MerchantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantsApiFp(configuration)
    return {
        /**
         * Add a new processor configuration to a merchant
         * @summary Create processor configuration
         * @param {string} merchantId Merchant ID
         * @param {CreateProcessorConfigRequest} createProcessorConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchantProcessorV1(merchantId: string, createProcessorConfigRequest: CreateProcessorConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcessorConfiguration> {
            return localVarFp.createMerchantProcessorV1(merchantId, createProcessorConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Merchant with at least one payment processor
         * @summary Create a new merchant
         * @param {CreateMerchantRequest} createMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchantV1(createMerchantRequest: CreateMerchantRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantResponse> {
            return localVarFp.createMerchantV1(createMerchantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update the payment configuration for a merchant (idempotent operation, restricted to partner owning the merchant)
         * @summary Create or update merchant payment configuration
         * @param {string} merchantId Merchant ID
         * @param {UpdatePaymentConfigurationRequest} updatePaymentConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateMerchantPaymentConfigurationV1(merchantId: string, updatePaymentConfigurationRequest: UpdatePaymentConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createOrUpdateMerchantPaymentConfigurationV1(merchantId, updatePaymentConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a merchant. Can only delete merchants with no payment sessions.
         * @summary Delete merchant
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantV1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMerchantV1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Disconnect a processor from a merchant. This operation allows processor deletion regardless of profileId or merchant status.  **Automatic Merchant Status Update:** - If the processor being deleted has status ACTIVE - AND the merchant status is ACTIVE - THEN the merchant status will be automatically changed to INACTIVE - AND a merchant.status.changed event will be emitted  **Validation:** - Processor cannot be deleted if it has active transactions in progress  **Event Emission:** When an ACTIVE processor is deleted from an ACTIVE merchant, a merchant.status.changed event is emitted with: - merchantId: The merchant identifier - previousStatus: \"ACTIVE\" - newStatus: \"INACTIVE\" - reason: \"MANUAL_UPDATE\" - description: Details about the processor deletion 
         * @summary Disconnect processor
         * @param {string} merchantId Merchant ID
         * @param {string} processorId Processor ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectMerchantProcessorV1(merchantId: string, processorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disconnectMerchantProcessorV1(merchantId, processorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the payment configuration for a merchant (public endpoint)
         * @summary Get merchant payment configuration
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantPaymentConfigurationV1(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentConfigurationResponse> {
            return localVarFp.getMerchantPaymentConfigurationV1(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all processor configurations for a merchant
         * @summary Get merchant processor configurations
         * @param {string} merchantId Merchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantProcessorsV1(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessorConfiguration>> {
            return localVarFp.getMerchantProcessorsV1(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Merchant
         * @summary Get merchant by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantV1(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MerchantResponse> {
            return localVarFp.getMerchantV1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List Merchants
         * @summary List merchants
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {MerchantStatus} [status] 
         * @param {string} [taxId] 
         * @param {string} [sort] 
         * @param {ListMerchantsV1DirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantsV1(page?: number, size?: number, status?: MerchantStatus, taxId?: string, sort?: string, direction?: ListMerchantsV1DirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<PagedMerchantResponse> {
            return localVarFp.listMerchantsV1(page, size, status, taxId, sort, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Suspend a Merchant (.NET platform only)
         * @summary Suspend merchant
         * @param {string} id 
         * @param {SuspendMerchantRequest} suspendMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendMerchantStatusV1(id: string, suspendMerchantRequest: SuspendMerchantRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuspendMerchantResponse> {
            return localVarFp.suspendMerchantStatusV1(id, suspendMerchantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a Merchant\'s status (Platform Admin only)
         * @summary Update merchant status
         * @param {string} id 
         * @param {UpdateMerchantStatus} updateMerchantStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantStatusV1(id: string, updateMerchantStatus: UpdateMerchantStatus, options?: RawAxiosRequestConfig): AxiosPromise<MerchantResponse> {
            return localVarFp.updateMerchantStatusV1(id, updateMerchantStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a Merchant details
         * @summary Update merchant
         * @param {string} id 
         * @param {UpdateMerchantRequest} updateMerchantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantV1(id: string, updateMerchantRequest: UpdateMerchantRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantResponse> {
            return localVarFp.updateMerchantV1(id, updateMerchantRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantsApi - object-oriented interface
 * @export
 * @class MerchantsApi
 * @extends {BaseAPI}
 */
export class MerchantsApi extends BaseAPI {
    /**
     * Add a new processor configuration to a merchant
     * @summary Create processor configuration
     * @param {string} merchantId Merchant ID
     * @param {CreateProcessorConfigRequest} createProcessorConfigRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public createMerchantProcessorV1(merchantId: string, createProcessorConfigRequest: CreateProcessorConfigRequest, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).createMerchantProcessorV1(merchantId, createProcessorConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Merchant with at least one payment processor
     * @summary Create a new merchant
     * @param {CreateMerchantRequest} createMerchantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public createMerchantV1(createMerchantRequest: CreateMerchantRequest, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).createMerchantV1(createMerchantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update the payment configuration for a merchant (idempotent operation, restricted to partner owning the merchant)
     * @summary Create or update merchant payment configuration
     * @param {string} merchantId Merchant ID
     * @param {UpdatePaymentConfigurationRequest} updatePaymentConfigurationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public createOrUpdateMerchantPaymentConfigurationV1(merchantId: string, updatePaymentConfigurationRequest: UpdatePaymentConfigurationRequest, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).createOrUpdateMerchantPaymentConfigurationV1(merchantId, updatePaymentConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a merchant. Can only delete merchants with no payment sessions.
     * @summary Delete merchant
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public deleteMerchantV1(id: string, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).deleteMerchantV1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disconnect a processor from a merchant. This operation allows processor deletion regardless of profileId or merchant status.  **Automatic Merchant Status Update:** - If the processor being deleted has status ACTIVE - AND the merchant status is ACTIVE - THEN the merchant status will be automatically changed to INACTIVE - AND a merchant.status.changed event will be emitted  **Validation:** - Processor cannot be deleted if it has active transactions in progress  **Event Emission:** When an ACTIVE processor is deleted from an ACTIVE merchant, a merchant.status.changed event is emitted with: - merchantId: The merchant identifier - previousStatus: \"ACTIVE\" - newStatus: \"INACTIVE\" - reason: \"MANUAL_UPDATE\" - description: Details about the processor deletion 
     * @summary Disconnect processor
     * @param {string} merchantId Merchant ID
     * @param {string} processorId Processor ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public disconnectMerchantProcessorV1(merchantId: string, processorId: string, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).disconnectMerchantProcessorV1(merchantId, processorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the payment configuration for a merchant (public endpoint)
     * @summary Get merchant payment configuration
     * @param {string} merchantId Merchant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public getMerchantPaymentConfigurationV1(merchantId: string, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).getMerchantPaymentConfigurationV1(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all processor configurations for a merchant
     * @summary Get merchant processor configurations
     * @param {string} merchantId Merchant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public getMerchantProcessorsV1(merchantId: string, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).getMerchantProcessorsV1(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Merchant
     * @summary Get merchant by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public getMerchantV1(id: string, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).getMerchantV1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Merchants
     * @summary List merchants
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {MerchantStatus} [status] 
     * @param {string} [taxId] 
     * @param {string} [sort] 
     * @param {ListMerchantsV1DirectionEnum} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public listMerchantsV1(page?: number, size?: number, status?: MerchantStatus, taxId?: string, sort?: string, direction?: ListMerchantsV1DirectionEnum, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).listMerchantsV1(page, size, status, taxId, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suspend a Merchant (.NET platform only)
     * @summary Suspend merchant
     * @param {string} id 
     * @param {SuspendMerchantRequest} suspendMerchantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public suspendMerchantStatusV1(id: string, suspendMerchantRequest: SuspendMerchantRequest, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).suspendMerchantStatusV1(id, suspendMerchantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a Merchant\'s status (Platform Admin only)
     * @summary Update merchant status
     * @param {string} id 
     * @param {UpdateMerchantStatus} updateMerchantStatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public updateMerchantStatusV1(id: string, updateMerchantStatus: UpdateMerchantStatus, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).updateMerchantStatusV1(id, updateMerchantStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a Merchant details
     * @summary Update merchant
     * @param {string} id 
     * @param {UpdateMerchantRequest} updateMerchantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantsApi
     */
    public updateMerchantV1(id: string, updateMerchantRequest: UpdateMerchantRequest, options?: RawAxiosRequestConfig) {
        return MerchantsApiFp(this.configuration).updateMerchantV1(id, updateMerchantRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListMerchantsV1DirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ListMerchantsV1DirectionEnum = typeof ListMerchantsV1DirectionEnum[keyof typeof ListMerchantsV1DirectionEnum];
